import FormValidator from "../form-validation/formvalidator";

if (document.querySelector('[getvalue="base"]')) {
    let valueBase = document.querySelector('[getvalue="base"]');
    const formvalidator = new FormValidator(valueBase.closest('form'),false);

    let valueBaseChildren = Array.from(valueBase.children);
    let listValuesFromBase = new Map();
    let allRadioButtons = document.querySelectorAll('[getvaluechoice]');
    let dynamicVariable = {};

    if (allRadioButtons) {
        let divsWhereCopyData = document.querySelectorAll('[setValue]');
        let divsWhereCopyDataChildren;
        let getValue = '';

        //value storage from address correspondence and power

        divsWhereCopyData.forEach(div => {
            let attributeName = div.getAttribute('setValue');
            dynamicVariable[attributeName] = new Map();
        });

        let listBase = valueBase.querySelectorAll('input');
        /** create empty map base */
        listBase.forEach(inputBase => {
            listValuesFromBase.set(inputBase.getAttribute('copyvalue'), '');
        });
        listBase.forEach(inputBase =>{
            listValuesFromBase.set(inputBase.getAttribute('copyvalue'), '');
            inputBase.addEventListener('input', function () {
                setValueBase(listValuesFromBase, inputBase);
            });
        });


        allRadioButtons.forEach((radio, index) => {
            let listWhereCopyValue = radio.attributes['getvaluechoice'].value.split(','); // lista
            let radioInputs = Array.from(radio.getElementsByTagName('input'));


            radioInputs.forEach(rInput => {
                rInput.addEventListener('change', function () {

                    if (rInput.value === '1' && rInput.checked) {
                        let choiceRadioInput = rInput.closest('[getvaluechoice]').getAttribute('getvaluechoice');

                        copyValueBase(valueBaseChildren, divsWhereCopyData, listWhereCopyValue,rInput);

                        // copyValue(divsWhereCopyData, listWhereCopyValue);
                        divsWhereCopyData.forEach(el => {

                            if (listWhereCopyValue.includes(el.attributes['setValue'].value)) {
                                setValueAndCheckValidation(Array.from(el.children));
                            }

                            checkMaps(listValuesFromBase, dynamicVariable[choiceRadioInput]);

                            let elSetValue = el.getAttribute('setvalue');
                            if(typeof dynamicVariable === 'object' &&
                                dynamicVariable !== null &&
                                dynamicVariable.hasOwnProperty(elSetValue) &&
                                elSetValue !== choiceRadioInput &&
                                dynamicVariable[elSetValue] !== undefined &&
                                dynamicVariable[elSetValue].size !== 0)
                            {
                                let listInput = el.querySelectorAll('input');
                                listInput.forEach(inputChange =>{
                                    let inputChangeCopyValue = inputChange.getAttribute('copyvalue');
                                    let inputChangeSetValue = inputChange.closest('[setvalue]').getAttribute('setvalue');
                                    let rInputSetValue = rInput.closest('[getvaluechoice]').getAttribute('getvaluechoice');

                                    if((dynamicVariable[elSetValue].get(inputChangeCopyValue) ) && (inputChangeSetValue === rInputSetValue)) {
                                        inputChange.value = dynamicVariable[elSetValue].get(inputChangeCopyValue);
                                    }
                                });
                            }
                        });


                    } else {

                        divsWhereCopyData.forEach(el => {
                            if (listWhereCopyValue.includes(el.attributes['setValue'].value)) {
                                clearValue(Array.from(el.children));
                            }
                        });

                        allRadioButtons.forEach(elem => {
                            let listRadioInput = Array.from(elem.getElementsByTagName('input'));

                            listRadioInput.forEach(i => {

                                if (i.checked && i.value === '1') {
                                    divsWhereCopyData.forEach(el => {
                                        let listWhereCopyValueNew = elem.attributes['getvaluechoice'].value.split(',');
                                        if (listWhereCopyValueNew.includes(el.attributes['setValue'].value) &&
                                            areMapsEqual(listValuesFromBase, dynamicVariable[el.attributes['setValue'].value]) )
                                        {

                                            setValueAndCheckValidation(Array.from(el.children))
                                        }
                                    });
                                }
                            });
                        });
                    }
                })
            })
        });

        divsWhereCopyData.forEach(divInputs =>{
            if(divInputs.getAttribute('setvalue')){
                let listInputs = divInputs.querySelectorAll("input");
                listInputs.forEach(inputChange =>{

                    inputChange.addEventListener('input', function () {
                        checkValueAndTriggerClickRadio(divInputs, listInputs);
                    });
                });
            }
        })
    }

    function setValueBase(listValuesFromBase, inputBase){
        listValuesFromBase.set(inputBase.getAttribute('copyvalue'), inputBase.value);
        Object.keys(dynamicVariable).forEach(key1 => {
            if (dynamicVariable[key1].size !== 0 && dynamicVariable[key1].size === listValuesFromBase.size && areMapsEqual(listValuesFromBase, dynamicVariable[key1])){
                for (let [key, value] of dynamicVariable[key1]) {
                    if (listValuesFromBase.has(key) || listValuesFromBase[key1].get(key) === value) {
                        allRadioButtons.forEach(radio => {
                            if(radio.getAttribute('getvaluechoice') === key1){
                                radio.querySelector('input[value="1"]').click();
                            }
                        });
                    }
                }
            }
        });
    }
    function copyValueBase(valueBaseChildren, divsWhereCopyData, listWhereCopyValue,rInput){
        valueBaseChildren.forEach(boxs => {
            listValuesFromBase.set(boxs.getElementsByTagName('input')[0].getAttribute('copyvalue'), boxs.getElementsByTagName('input')[0].value);

            boxs.getElementsByTagName('input')[0].addEventListener("input", function (e) {
                listValuesFromBase.set(e.target.getAttribute('copyvalue'), e.target.value);

                if(rInput.value === '1' && rInput.checked){
                    copyValue(divsWhereCopyData, listWhereCopyValue)
                }

            });
        });
    }

    function copyValue(divsWhereCopyData, listWhereCopyValue){
        divsWhereCopyData.forEach(el => {
            if (listWhereCopyValue.includes(el.attributes['setValue'].value)) {
                setValueAndCheckValidation(Array.from(el.children));
            }
        });
    }

    function clearValue (list){
        list.forEach(childbox => {
            childbox.getElementsByTagName('input')[0].value = '';
            childbox.getElementsByTagName('input')[0].disabled = false;
        });
    }
    function setValueAndCheckValidation(list){
        list.forEach(el => {
            let inputElement = el.getElementsByTagName('input')[0];
            inputElement.value = listValuesFromBase.get(inputElement.getAttribute('copyvalue'));
            formvalidator.checkValidationType(inputElement);
        });
    }

    function checkMaps(valueMap1,valueMap2){
        if(areMapsEqual(valueMap1, valueMap2) ){
            for (const [key, value] of valueMap1) {
                valueMap2.set(key, value);
            }
        }
    }

    function areMapsEqual(map1, map2) {
        if (map1.size !== map2.size) {
            return false;
        }

        for (const [key, value] of map1) {
            if (!map2.has(key)) {
                return false;
            }

            const val1 = value;
            const val2 = map2.get(key);

            if (typeof val1 === 'object' && typeof val2 === 'object') {
                if (!areObjectsEqual(val1, val2)) {
                    return false;
                }
            } else if (val1 !== val2) {
                return false;
            }
        }

        return true;
    }

    function areObjectsEqual(obj1, obj2) {
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);

        if (keys1.length !== keys2.length) {
            return false;
        }

        for (const key of keys1) {
            if (obj1[key] !== obj2[key]) {
                return false;
            }
        }

        return true;
    }

    function checkValueAndTriggerClickRadio(divInputs, listInputs){
        let setValue = divInputs.getAttribute('setvalue');
        let findRadio = document.querySelector(`[getvaluechoice="${setValue}"]`);
        //save all value
        listInputs.forEach(inputChange =>{
            dynamicVariable[setValue].set(inputChange.getAttribute('copyvalue'), inputChange.value);
        });
        // getValue = inputChange.value;
        findRadio.querySelector('input[value="0"]').click();
        // inputChange.value = getValue;
        listInputs.forEach(inputChange =>{
            if(dynamicVariable[setValue].get(inputChange.getAttribute('copyvalue'))){
                inputChange.value = dynamicVariable[setValue].get(inputChange.getAttribute('copyvalue'));
            }
        });
        if (listValuesFromBase.size !== 0 && dynamicVariable[setValue].size === listValuesFromBase.size && areMapsEqual(listValuesFromBase, dynamicVariable[setValue])) {
            let allValuesMatch = Array.from(listValuesFromBase).every(([key, value]) => {
                return Array.from(listInputs).find(input => input.value === value);
            });
            if (allValuesMatch) {
                findRadio.querySelector('input[value="1"]').click();
            }
        }
    }
}